import React from 'react';
import './main.css';

const steps = [
  {
    number: '01',
    title: 'Browse',
    description: 'Explore our room and its full inclusions below.',
  },
  {
    number: '02',
    title: 'Message Us',
    description: 'Reach out on Telegram to check availability.',
  },
  {
    number: '03',
    title: 'Confirm & Arrive',
    description: "We'll confirm your booking. Just show up.",
  },
];

const Main = () => {
  return (
    <section className="main fade-section" id="book">
      <div className="main__inner">
        <h2 className="main__heading">How to Reserve</h2>
        <div className="steps-row">
          {steps.map((step, index) => (
            <React.Fragment key={index}>
              <div className="step">
                <span className="step__number">{step.number}</span>
                <h3 className="step__title">{step.title}</h3>
                <p className="step__description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step__connector"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Main;
